import { Link } from "@remix-run/react";

interface PricingCardProps {
  title: string;
  price: string;
  description: string;
  features: string[];
  ctaText: string;
  ctaLink: string;
  highlighted?: boolean;
}

export function PricingCard({
  title,
  price,
  description,
  features,
  ctaText,
  ctaLink,
  highlighted = false,
}: PricingCardProps) {
  return (
    <div
      className={`flex h-full flex-col rounded-2xl p-8 transition-all duration-200 hover:scale-105 ${
        highlighted
          ? "bg-indigo-500 text-white shadow-xl"
          : "bg-white text-gray-600 shadow-lg"
      }`}
    >
      <h3 className="text-2xl font-bold">{title}</h3>
      <p className="mt-4 text-sm opacity-90">{description}</p>
      <div className="mt-6">
        <span className="text-4xl font-bold">{price}</span>
        {price !== "Kostenlos" && (
          <span
            className={`ml-1 ${highlighted ? "text-white" : "text-gray-500"}`}
          >
            / pro Paket
          </span>
        )}
      </div>
      <ul className="mt-8 flex-1 space-y-4">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center">
            <svg
              className={`h-5 w-5 ${
                highlighted ? "text-white" : "text-primary-500"
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="ml-3 text-sm">{feature}</span>
          </li>
        ))}
      </ul>
      <Link
        to={ctaLink}
        className={`mt-8 block w-full rounded-xl px-6 py-3 text-center font-medium transition-colors ${
          highlighted
            ? "bg-white text-indigo-600 hover:bg-gray-200"
            : "bg-indigo-500 text-white hover:bg-indigo-700"
        }`}
      >
        {ctaText}
      </Link>
    </div>
  );
}
